/**
 * Asynchronously loads the component for HomePage
 */

import { lazyLoad } from 'utils/loadable';

export const ConfigPage = lazyLoad(
  () => import('./index'),
  module => module.ConfigPage
);
